// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as PriceCalculator from "../../core/PriceCalculator.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function PriceRateTableCell(props) {
  let computedRate = PriceCalculator.Retail.Rate.apply(props.valueExcludingTax, props.rateType, props.purchasePrice, 0, props.taxRate);
  let formattedRate = computedRate !== undefined ? computedRate.toFixed(2).replace(".", ",") + " %" : "—";
  return JsxRuntime.jsx(TextStyle.make, {
    children: formattedRate
  });
}

let make = React.memo(PriceRateTableCell);

export {
  make,
}
/* make Not a pure module */
